import PartnerModuleConfiguration from "./PartnerModuleConfiguration";
import {PartnersControllerName, PartnerServiceName} from "../utils/names/serviceNames";
import {PartnersController} from "./controller/root/PartnersController";
import {PartnerService} from "./service/PartnerService";
import {PartnersTableComponent} from "./controller/table/PartnersTableComponent";

PartnerModuleConfiguration.createNewModule()
    .controller(PartnersControllerName, PartnersController.instance)
    .component('partnersTable', PartnersTableComponent.instance)
    .service(PartnerServiceName, PartnerService.instance);